import { TGetClaimedPrizeWinsResponse } from '@daymade/api-contracts';
import { MAIN_PRIZE_STRUCTURE_CODE } from '@daymade/common-lib/constants';
import ImageWithFallback from 'components/ImageWithFallback';
import { dashboardFolder } from 'constants/Dashboard';
import styles from './ClaimedPrize.module.css';
import {
  getDisplayPrizeTierCode,
  getPrizeTierIcon,
} from './prizeTierCodeImageMap';

interface ClaimedPrizeProps {
  className?: string;
  prizeWinId: string;
  prizeStructureCode: string;
  prizeTierCode: string;
  createdAt: Date | string;
  chosenAt: TGetClaimedPrizeWinsResponse[number]['chosenAt'];
  chosenPrizeName: TGetClaimedPrizeWinsResponse[number]['chosenPrizeName'];
  chosenPrizeImageLocation: TGetClaimedPrizeWinsResponse[number]['chosenPrizeImageLocation'];
}

export const ClaimedPrize = ({
  className,
  prizeStructureCode,
  prizeTierCode,
  createdAt,
  chosenAt,
  chosenPrizeName,
  chosenPrizeImageLocation,
}: ClaimedPrizeProps) => {
  const displayDate = chosenAt ?? createdAt;
  const selectedProductName = chosenPrizeName;
  const shouldShowTierRow = prizeStructureCode === MAIN_PRIZE_STRUCTURE_CODE;
  const displayPrizeTierCode = getDisplayPrizeTierCode(prizeTierCode);

  return (
    <div
      className={
        className ? `${styles.container} ${className}` : styles.container
      }
    >
      <div className={styles.prizeImage}>
        <ImageWithFallback
          layout="fill"
          objectFit="cover"
          src={chosenPrizeImageLocation || ''}
          fallbackSrc={`${dashboardFolder}/FALLBACK_YOUR_WINS.png`}
        />
      </div>
      <div className={styles.textSection}>
        {selectedProductName ? (
          <h3
            className={`aboutUsTypographyHeaderMedium textAlignLeft noMargin ${styles.title}`}
          >
            {selectedProductName}
          </h3>
        ) : null}
        {shouldShowTierRow ? (
          <div className={styles.tierRow}>
            <div className={styles.tierIcon}>
              <ImageWithFallback
                layout="fill"
                src={getPrizeTierIcon(prizeTierCode)}
              />
            </div>
            <p className="aboutUsTypographyBodySmall noMargin">
              {displayPrizeTierCode} prize
            </p>
          </div>
        ) : null}
        <p className="aboutUsTypographyBodySmall noMargin">
          Claimed:{' '}
          {new Date(displayDate)
            .toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })
            .replace(/(\w{3})\s(\d{4})/, '$1, $2')}
        </p>
      </div>
    </div>
  );
};
